<template>
  <div v-loading="isLoading">
    <SSearchTable
      :config="config"
      :group-id="groupId"
      :cell-renderers="cellRenderers"
      @loading-state:changed="onLoadingChanged"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { SSearchTable } from "@smeetz/ui-components";

import { buildCustomersSearchTableConfig } from "./customers-search-table.config";
import CustomerActionsCell from "./custom-cells/CustomerActionsCell/CustomerActionsCell.vue";
import CustomerCountryCell from "./custom-cells/CustomerCountryCell/CustomerCountryCell.vue";

type Props = {
  groupId: number;
};

defineProps<Props>();

const config = buildCustomersSearchTableConfig();

const cellRenderers = {
  actions: CustomerActionsCell,
  country: CustomerCountryCell,
};

const isLoading = ref(true);

/**
 * Mirror SSearchTable's loading state into the el-loading overlay.
 *
 * @param {boolean} loading - True when fetch is in-flight, false on settle.
 * @returns {boolean} Sentinel.
 */
function onLoadingChanged(loading: boolean): boolean {
  isLoading.value = loading;

  return true;
}
</script>
